import React, { useEffect, useState } from "react";
import { SelectInput } from "components/form";
import { getCollection } from "utils/getCollection";
import CurrentSemester from "components/users/fields/academic/CurrentSemester";

export default (props) => {
  const [label, setLabel] = useState("Período letivo atual");
  const [collection, setCollection] = useState([]);
  const [numeral, setNumeral] = useState([]);

  const main_education_type = _.get(props.getValues?.(), "main_education_type") || "";

  const labels = {
    "semester": "Semestre atual",
    "bimester": "Bimestre atual",
    "year": "Ano atual",
    "module": "Módulo atual",
    "four_month_period": "Quadrimestre atual",
  }

  const handleChange = (value) => {
    if (collection.some(v => v.value === value)) {
      setLabel(labels[value]);
    } else {
      setLabel("Período letivo atual");
    }
  }

  const mountNumeralCollection = () => {
    let values = [], min, max;

    if (main_education_type === "elementary_school") {
      [min, max] = [5, 9];
    } else if (main_education_type === "high_school") {
      [min, max] = [1, 3];
    } else if (main_education_type === "technical" || main_education_type === "high_school_technical") {
      [min, max] = [1, 4];
    } else {
      [min, max] = [1, 20];
    }

    for (let i = min; i <= max; i++) {
      values.push({ value: i, label: i });
    }

    setNumeral(values);
  }

  const checkDefaultCurrentSemester = () => {
    const current_semester = _.get(props.getValues?.(), "current_semester");

    if (!numeral.some((v) => v.value === current_semester)) {
      props.resetField("current_semester", { defaultValue: null });
    }
  }

  useEffect(() => {
      if(main_education_type !== null && main_education_type !== "") {
          getCollection(`/selects/${main_education_type}/ies_periods.json`, setCollection);

          mountNumeralCollection();
      }
  }, [main_education_type]);

  useEffect(() => {
    if (main_education_type === "elementary_school" || main_education_type === "high_school") {
      props.resetField("ies_period", { defaultValue: "year" });
    } else {
      let defaultValue = _.get(props.getValues?.(), "ies_period");

      if (!_.isEmpty(collection) && !collection.some(v => v.value === defaultValue)) {
        props.resetField("ies_period", { defaultValue: null });
      }
    }
  }, [collection])

  useEffect(() => {
    if (!_.isEmpty(numeral)) checkDefaultCurrentSemester();
  }, [numeral])

  return (
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <SelectInput
            {...props}
            handleChange={handleChange}
            placeholder="Selecione..."
            name="ies_period"
            id="ies_period"
            collection={collection}
            label={props.label || "Período letivo"}
          />
        </div>
      </div>
      <div className="col-md-6">
        <CurrentSemester {...props} collection={numeral} label={label} autoFocus={false} />
      </div>
    </div>
  )
}
